import { useState } from "react";
import { toast } from "sonner";
import { Upload, Loader2 } from "lucide-react";
import { uploadImage, errMsg } from "../../lib/api";
import { inputCls, btnGhost } from "./styles";

export const ImageField = ({ value, onChange, testid }) => {
  const [uploading, setUploading] = useState(false);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      onChange(await uploadImage(file));
      toast.success("تم رفع الصورة");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  };

  return (
    <div className="space-y-2">
      <div className="flex gap-2">
        <input
          data-testid={`${testid}-url`}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="رابط الصورة (https://...)"
          dir="ltr"
          className={`${inputCls} text-left`}
        />
        <label data-testid={`${testid}-upload-btn`} className={`${btnGhost} flex items-center gap-1.5 cursor-pointer shrink-0`}>
          {uploading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />}
          {uploading ? "جارٍ الرفع..." : "رفع من الجهاز"}
          <input type="file" accept="image/*" className="hidden" onChange={pick} disabled={uploading} />
        </label>
      </div>
      {value && (
        <img src={value} alt="معاينة" data-testid={`${testid}-preview`} className="h-24 rounded-lg border border-[#28282D] object-cover" />
      )}
    </div>
  );
};
